// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTwoFingerTouch_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 14.5L23.0512 17.2349C23.7169 18.1225 24.922 18.407 25.9144 17.9108C26.9585 17.3888 27.4414 16.1684 27.0487 15.0751L26.8596 14.5478C25.2825 10.1479 24.107 6.86854 21 4.04871V0H19V4.95994L19.3492 5.25926C22.3117 7.79854 23.3487 10.6875 25.052 15.4324L25.1665 15.7512C25.2187 15.8966 25.1531 16.0554 25.0199 16.122C24.8921 16.1859 24.7369 16.1493 24.6512 16.0349L22 12.5C21.039 11.2186 19 11.8983 19 13.5L19 24C19 24.5523 18.5523 25 18 25C17.4477 25 17 24.5523 17 24V16H15V25C15 25.5523 14.5523 26 14 26C13.4477 26 13 25.5523 13 25V15L12.9999 14.9851C11.6371 14.7396 10.4387 14.2906 9.68394 13.583C8.97994 12.923 8.54719 11.9343 8.97014 10.2425C9.42986 8.40366 10.3588 6.76691 11.1942 5.57346C11.6091 4.98085 11.9937 4.50764 12.2724 4.18487C12.4116 4.0237 12.5239 3.90065 12.5997 3.8196C12.6375 3.7791 12.6662 3.74914 12.6845 3.73022L12.7041 3.71019L12.7071 3.70711L13 3.41421L13 0H11V2.60463C10.9299 2.68209 10.8489 2.77333 10.7588 2.87763C10.4438 3.24236 10.0159 3.76915 9.55577 4.42654C8.64118 5.73309 7.57014 7.59634 7.02986 9.75746C6.4528 12.0657 7.02006 13.827 8.31606 15.042C9.06621 15.7453 10.0147 16.2216 11 16.5448V25C11 26.6569 12.3431 28 14 28C15.0623 28 15.9956 27.4479 16.5286 26.615C16.9634 26.8601 17.4653 27 18 27C19.6569 27 21 25.6569 21 24V14.5Z" class="svg-bg"/>
  <path d="M9 24H7.5599L0.226562 32H31.773L24.4397 24H23V26H23.5599L27.2266 30H4.77303L8.4397 26H9V24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTwoFingerTouch is a generated icon component.
 */
let IconRmsTwoFingerTouch = IconRmsTwoFingerTouch_1 = class IconRmsTwoFingerTouch extends IconBaseElement {
    render() {
        return html `${IconRmsTwoFingerTouch_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTwoFingerTouch.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsTwoFingerTouch = IconRmsTwoFingerTouch_1 = __decorate([
    customElement('zui-icon-rms-two-finger-touch')
], IconRmsTwoFingerTouch);
export { IconRmsTwoFingerTouch };
